import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { USECASES } from "@/lib/usecases";
import { BrandWordmark } from "./BrandWordmark";
import { NEWS_PATH } from "@/lib/news";

export default function Footer() {
  const { t, lang: pageLang } = useLang();
  // Footer-Verlinkungen gibt es nur DE/EN; andere Sprachen nutzen die EN-Fassung
  const lang = pageLang === "de" ? "de" : "en";
  return (
    <footer data-testid="site-footer" className="relative bg-[#0F1114] border-t border-white/8 pt-16 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div translate="no" className="notranslate inline-flex items-center gap-2 font-display font-semibold tracking-[0.24em] text-sm text-white">
              <BrandWordmark lineClass="bg-white/80" />
            </div>
            <p className="mt-6 font-display text-xl text-[#F5D77A] leading-tight max-w-sm">
              {t.footer.claim}
            </p>
            <p className="mt-4 text-white/55 max-w-sm leading-relaxed text-sm">{t.footer.mission}</p>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-white/35 mb-4">
              {lang === "de" ? "Anwendungen" : "Use cases"}
            </div>
            <nav className="flex flex-col gap-2 text-sm mb-8">
              {USECASES.map((u) => (
                <Link
                  key={u.key}
                  to={lang === "en" ? `/en/${u.enSlug}` : `/${u.deSlug}`}
                  data-testid={`footer-link-${u.key}`}
                  className="text-white/70 hover:text-[#F5D77A] transition-colors w-fit"
                >
                  {u[lang].h1}
                </Link>
              ))}
            </nav>
            <div className="text-[11px] tracking-[0.3em] uppercase text-white/35 mb-4">Weitere Seiten</div>
            <nav className="flex flex-col gap-2 text-sm">
              <Link
                to={NEWS_PATH[lang]}
                data-testid="footer-link-aktuelles"
                className="text-white/70 hover:text-[#F5D77A] transition-colors w-fit"
              >
                {lang === "de" ? "Aktuelles" : "News"}
              </Link>
              <Link
                to="/breitscheidplatz"
                data-testid="footer-link-breitscheidplatz"
                className="text-white/70 hover:text-[#F5D77A] transition-colors w-fit"
              >
                Breitscheidplatz — Vorschlag
              </Link>
              <Link
                to="/impressum"
                data-testid="footer-link-impressum"
                className="text-white/70 hover:text-[#F5D77A] transition-colors w-fit"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-link-datenschutz"
                className="text-white/70 hover:text-[#F5D77A] transition-colors w-fit"
              >
                Datenschutz
              </Link>
            </nav>
          </div>
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-white/35 mb-4">Kontakt</div>
            <a href="mailto:info@berlin-cube.de" translate="no" className="notranslate block text-white hairline w-fit" data-testid="footer-email">
              info@berlin-cube.de
            </a>
            <a href="tel:+4917613600041" translate="no" className="notranslate block text-white/60 hairline w-fit mt-2" data-testid="footer-phone">
              +49 176 13600041
            </a>
            <a href="https://www.berlin-cube.de" translate="no" className="notranslate block text-white/60 hairline w-fit mt-2">
              www.berlin-cube.de
            </a>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[11px] tracking-[0.28em] uppercase text-white/35 space-y-1.5">
            <div translate="no" className="notranslate" data-testid="footer-copyright">
              © {new Date().getFullYear()} Martin Fichtelmann · Berlin-Cube
            </div>
          </div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-white/35">Designed in Berlin</div>
        </div>
      </div>
    </footer>
  );
}
